// extracted by mini-css-extract-plugin
export default {"wrap":"s2WmyYqDIONuRoBklDcB","breadcrumb":"wGqCpfZ_OZ1BCKr35OAJ","icon":"IeLB3xU8ujyxjgKn_Sv5","link":"pr9ibNCSKZl6N7QmuqOH"};